<div class="shipment_status" ><span *ngIf="params.Status" class="column_value column_value--chip column_value--chip-{{ params.Status ? (params.Status | lowercase) : ''}}"><i
    class="far"    
  ></i>{{ params.Status ? (params.Status | textCapitalize)  : "" }}</span></div>